"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var WrappedPropertyCtor_1 = require("./WrappedPropertyCtor");
var WrapperPropertyArrayItem = /** @class */ (function () {
    function WrapperPropertyArrayItem(dest, parent, key, schema, options) {
        this.$key = key;
        this._dest = dest;
        this._parent = parent;
        this._schema = schema;
        this._options = options;
        if (options.wrapAll) {
            this._cache = new WrappedPropertyCtor_1.default[this._schema.type](this._dest, this._parent, this.$key, this._schema, this._options);
        }
    }
    Object.defineProperty(WrapperPropertyArrayItem.prototype, "$item", {
        get: function () {
            if (this._cache) {
                return this._cache;
            }
            else {
                // console.log('WrappedPropertyCtor', Ctor);
                return (this._cache = new WrappedPropertyCtor_1.default[this._schema.type](this._dest, this._parent, this.$key, this._schema, this._options));
            }
        },
        enumerable: true,
        configurable: true
    });
    WrapperPropertyArrayItem.prototype.$clearCache = function () {
        if (this._cache) {
            this._cache.$destroy();
            this._cache = undefined;
        }
    };
    /**
     * ustawienie $dirty na false ale tylko wtedy gdy jest pobrane
     */
    WrapperPropertyArrayItem.prototype.$reset = function () {
        if (this._cache) {
            this._cache.$reset();
        }
    };
    /**
     *
     */
    WrapperPropertyArrayItem.prototype.$dirtyList = function (result) {
        if (this._cache) {
            this._cache.$dirtyList(result);
        }
        return result;
    };
    WrapperPropertyArrayItem.prototype.$destroy = function () {
        this.$clearCache();
    };
    WrapperPropertyArrayItem.prototype.$setKey = function (newKey) {
        this.$key = newKey;
        if (this._cache) {
            this._cache.$key = newKey;
        }
    };
    return WrapperPropertyArrayItem;
}());
exports.WrapperPropertyArrayItem = WrapperPropertyArrayItem;
//# sourceMappingURL=WrappedPropertyArrayItem.js.map